import { LAYOUT_COMPONENT_TYPE, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const menuGrid3ColumnDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.menu,
  componentType: LAYOUT_COMPONENT_TYPE.menuGrid3Column,
  displayOrder: 2,
  content: {
    sectionTitle: loc3('Aus unserer Küche', 'From our kitchen', 'Từ bếp của chúng tôi'),
    menuData: {
      de: JSON.stringify([
        {
          title: 'Vorspeisen',
          items: [
            {
              name: 'Burrata',
              price: '14',
              description: 'Tomaten, Basilikumöl',
              allergenIds: ['milk'],
              dietaryTagIds: ['vegetarian', 'organic'],
            },
            {
              name: 'Carpaccio',
              price: '16',
              description: 'Rucola, Parmesan',
              allergenIds: ['cereals_containing_gluten', 'milk'],
              additiveIds: ['preservative'],
            },
          ],
        },
        {
          title: 'Pasta',
          items: [
            { name: 'Tagliatelle al ragù', price: '24', description: 'Geschmortes Rind' },
            {
              name: 'Risotto ai funghi',
              price: '22',
              description: 'Waldpilze',
              allergenIds: ['cereals_containing_gluten', 'milk'],
              dietaryTagIds: ['vegetarian'],
            },
          ],
        },
        {
          title: 'Hauptgerichte',
          items: [
            {
              name: 'Branzino',
              price: '32',
              description: 'Zitrone, Kapern',
              allergenIds: ['fish'],
              additiveIds: ['colorant'],
            },
            { name: 'Entenbrust', price: '34', description: 'Kirschen' },
          ],
        },
      ]),
      en: JSON.stringify([
        {
          title: 'Antipasti',
          items: [
            {
              name: 'Burrata',
              price: '14',
              description: 'Heirloom tomato, basil oil',
              allergenIds: ['milk'],
              dietaryTagIds: ['vegetarian', 'organic'],
            },
            {
              name: 'Carpaccio',
              price: '16',
              description: 'Arugula, aged parmesan',
              allergenIds: ['cereals_containing_gluten', 'milk'],
              additiveIds: ['preservative'],
            },
          ],
        },
        {
          title: 'Primi',
          items: [
            { name: 'Tagliatelle al ragù', price: '24', description: 'Slow-braised beef' },
            {
              name: 'Risotto ai funghi',
              price: '22',
              description: 'Wild mushrooms',
              allergenIds: ['cereals_containing_gluten', 'milk'],
              dietaryTagIds: ['vegetarian'],
            },
          ],
        },
        {
          title: 'Secondi',
          items: [
            {
              name: 'Branzino',
              price: '32',
              description: 'Lemon, capers, herbs',
              allergenIds: ['fish'],
              additiveIds: ['colorant'],
            },
            { name: 'Duck breast', price: '34', description: 'Cherry gastrique' },
          ],
        },
      ]),
      vi: JSON.stringify([
        {
          title: 'Khai vị',
          items: [
            {
              name: 'Burrata',
              price: '14',
              description: 'Cà chua, dầu húng quế',
              allergenIds: ['milk'],
              dietaryTagIds: ['vegetarian', 'organic'],
            },
            {
              name: 'Carpaccio',
              price: '16',
              description: 'Rucola, parmesan',
              allergenIds: ['cereals_containing_gluten', 'milk'],
              additiveIds: ['preservative'],
            },
          ],
        },
        {
          title: 'Món pasta',
          items: [
            { name: 'Tagliatelle al ragù', price: '24', description: 'Bò hầm chậm' },
            {
              name: 'Risotto ai funghi',
              price: '22',
              description: 'Nấm rừng',
              allergenIds: ['cereals_containing_gluten', 'milk'],
              dietaryTagIds: ['vegetarian'],
            },
          ],
        },
        {
          title: 'Món chính',
          items: [
            {
              name: 'Branzino',
              price: '32',
              description: 'Chanh, caper, thảo mộc',
              allergenIds: ['fish'],
              additiveIds: ['colorant'],
            },
            { name: 'Ức vịt', price: '34', description: 'Sốt cherry' },
          ],
        },
      ]),
    },
  },
  media: {},
};
